import styled from 'styled-components';
import { BodyRegularS, HeadingExtraBoldS } from '../../../styles/globals';
import {
  NAME_CELL_WIDTH,
  PHONE_CELL_WIDTH,
  LANGUAGE_CELL_WIDTH,
  TEAM_CELL_WIDTH,
  LEADER_CELL_WIDTH,
  ROLE_CELL_WIDTH,
  STATUS_CELL_WIDTH,
} from '../ParticipantsTableHeader/ParticipantTableHeader.styles';
import PencilIcon from '@/assets/icons/pencilIcon.svg?react';
import TrashIcon from '@/assets/icons/trashCanIcon.svg?react';

export const ResizeCont = styled.div`
  position: absolute;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 16px;
  cursor: pointer;

  svg {
    width: 7.5px;
    height: 14.92px;
  }

  ${({ theme }) => `
    margin: 0 ${theme.layout.spacing.centy} 0 0;
  `};
`;

export const ParticipantsTile = styled.div`
  position: relative;
  min-height: 60px;
  display: flex;
  align-items: center;
  align-self: center;
  box-sizing: border-box;

  ${({ theme }) => `
    margin: ${theme.layout.spacing.mili} ${theme.layout.spacing.centy} 0;
    padding: ${theme.layout.spacing.mikro} ${theme.layout.spacing.deka};
    gap: ${theme.layout.spacing.mikro};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};

    &:hover {
      background: ${theme.colors.primary[10]};

      #ActionIcons {
        display: flex;
      }
    }
  `};
`;

export const NameCont = styled.div`
  ${({ theme }) => `
    min-height: 50px;
    width: ${NAME_CELL_WIDTH};
    display: flex;
    padding: ${theme.layout.spacing.nano} 0;
    flex-flow: column nowrap;
    justify-content: space-between;
    justify-self: flex-start;
  `};
`;

export const Name = styled(HeadingExtraBoldS)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const Data = styled(BodyRegularS)`
  line-break: anywhere;
  font-size: 15px;

  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const Phone = styled(Data)`
  width: ${PHONE_CELL_WIDTH};
`;

export const Language = styled(Data)`
  width: ${LANGUAGE_CELL_WIDTH};
  padding-left: 36px;
`;

export const Team = styled(Data)`
  width: ${TEAM_CELL_WIDTH};
`;

export const Status = styled(Data)`
  width: ${STATUS_CELL_WIDTH};
  padding-left: 20px;
`;

export const ActionIconsCont = styled.div`
  position: absolute;
  right: 0;
  margin: 0 16px 0 0;
  display: none;
  align-items: center;
`;

export const DeleteParticipantIcon = styled(TrashIcon)`
  width: 18px;
  height: 18px;
  justify-self: flex-end;
  margin: 0 16px 0 0;
  cursor: pointer;
`;

export const EditParticipantIcon = styled(PencilIcon)`
  width: 18px;
  height: 18px;
  justify-self: flex-end;
  margin: 0 16px 0 0;
  cursor: pointer;
`;

export const Leader = styled(Data)`
  white-space: nowrap;
  overflow: hidden;
  width: ${LEADER_CELL_WIDTH};
  text-overflow: ellipsis;
`;

export const Role = styled(Data)`
  width: ${ROLE_CELL_WIDTH};
  text-transform: capitalize;
`;

export const IconImg = styled.img`
  ${({ theme }) => `
      margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;

interface FilledCircleProps {
  color?: 'green' | 'red';
}

export const FilledCircle = styled.div<FilledCircleProps>`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;

  ${({ theme, color }) => {
    let bgColor = theme.colors.neutral.primary[30];
    if (color === 'green') bgColor = theme.colors.support.green[100];
    if (color === 'red') bgColor = theme.colors.support.red[100];
    return `background-color: ${bgColor};`;
  }}
`;

export const Tooltip = styled.div`
  visibility: hidden;
  background-color: #808080;
  color: white;
  text-align: left;
  border-radius: 8px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 14px;
  line-height: 1.4;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: #808080 transparent transparent transparent;
  }
`;

export const StatusIconWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

export const TooltipDescription = styled.div`
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  text-overflow: ellipsis;
`;
